import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-achievements',
  templateUrl: './our-achievements.component.html',
  styleUrls: ['./our-achievements.component.css']
})
export class OurAchievementsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  	
  }

}
